import "../../CustomStyles/customStyle.css";
import Minagaramlogo from "../../assets/Agarathi_logo.png";
import PlayStorelogo from "../../assets/SharethisApp/PlayStore.svg";
import AppStorelogo from "../../assets/SharethisApp/AppStore.svg";
// import STA_MobileScreen from "../../assets/new_landing_page.png";
import ArrowUpRight from "../../assets/landing page/ArrowUpRight.png";
import { Button, Menu, message } from "antd";
import BackgroundImage from "../../assets/Background_image1.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import landing_image_mobile from "../../assets/mobile_back_ground_02.png";
import styles from "./landing_module.module.css";
import phone from "../../assets/mobile_back_ground_02.png";
import Footers_index from "../../Components/Footer/index_footer";
import { useNavigate } from "react-router-dom";
import mainscreenmobile from "../../assets/mainscreenmobile.png";
import mainscreenipad from "../../assets/mainscreenipad.png";
import childimg from "../../assets/childimg.png";
import dot_image from "../../assets/dot_image.png";
import tick from "../../assets/tick.png";
import iphone_scan from "../../assets/iphone_scan.png";
import android_scan from "../../assets/android_scan.png";
import recent_viewed from "../../assets/recent_viewed.png";
import wordofday from "../../assets/wordofday.png";
import smart_search from "../../assets/smart_search.png";
import quote from "../../assets/quote.png";
import arrow_line from "../../assets/arrow_line.png";
import feedstar from "../../assets/feedstar.png";
import feedbackbox from "../../assets/feedbackbox.png";
import bckgrd_box from "../../assets/bckgrd_box.png";
import ArrowUp from "../../assets/ArrowUp.png";
import recentview_tab from "../../assets/recentview_tab.png";
import wordofday_tab from "../../assets/wordofday_tab.png";
import smartsearch_tab from "../../assets/smartsearch_tab.png";
import download_button from "../../assets/download_button.png";
import profile_button from "../../assets/profile_button.png";
import recentview_phone from "../../assets/recentview_phone.png";
import wordofday_phone from "../../assets/wordofday_phone.png";
import smartsearch_phone from "../../assets/smartsearch_phone.png";
import {
  STR_Copy_Failure_STA,
  STR_Copy_STA,
  STR_Copy_Success_STA,
  STR_Tam_Copy_Failure_STA,
  STR_Tam_Copy_STA,
  STR_Tam_Copy_Success_STA,
} from "../../Config.js/Strings";
import { ArrowRightOutlined, LinkOutlined } from "@ant-design/icons";
import { WhatsappShareButton, WhatsappIcon } from "react-share";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
// import { Button } from "antd";
import LoginModal from "../../Pages/Authentication/Login";
import ForgetPasswordModal from "../../Pages/Authentication/ForgetPasswordView";
import SignUpModal from "../../Pages/Authentication/SignUp";
import user_icon from "../../assets/landing page/user_icon.png";
// import icon10 from "../../assets/Frame 9051.png";
import icon11 from "../../assets/inverted-commas1.png";
import { Link } from "react-router-dom";
import Word_of_the_image from "../../assets/landing page/word_of_the_day.png";
import image from "../../assets/landing page/image.png";
import audio from "../../assets/landing page/audio.png";
import select_level from "../../assets/landing page/select_level.png";
import recently_view from "../../assets/landing page/recentcly_view.png";
import saved from "../../assets/landing page/saved.png";
import idioms from "../../assets/landing page/idioms.png";
import topQuoteImage from "../../assets/right_x5F_quote.png";
import bottomQuoteImage from "../../assets/botton_left.png";
import { style } from "deprecated-react-native-prop-types/DeprecatedViewPropTypes";
import Footer from "../../Components/Footer/Footer";
const SharethisApp = ({ isTamil }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Login modal
  const [isForgotOpen, setIsForgotOpen] = useState(false); // Forgot password modal
  const [openSignUp, setOpenSignUp] = useState(false); // Signup modal
  // ---------- OPEN / CLOSE HANDLERS ----------
  const handleOpenLogin = () => setIsModalOpen(true);
  const handleCloseLogin = () => setIsModalOpen(false);

  const handleOpenForgot = () => setIsForgotOpen(true);
  const handleCloseForgot = () => setIsForgotOpen(false);

  const handleOpenSignUp = () => setOpenSignUp(true);
  const handleCloseSignUp = () => setOpenSignUp(false);
  const testimonials = [
    {
      text: "This app makes learning Tamil simple and enjoyable. The examples are so clear, and the Word of the Day keeps me motivated.",
      user: "Kannan",
      stars: 5,
    },
    {
      text: "I use Minagaram for school assignments. The meanings are accurate, and the grammar details help me understand every word better.",
      user: "Liam",
      stars: 4,
    },
    {
      text: " I can find meanings instantly. The smart search feature is super fast and precise. Great app for all levels!",
      user: "olivia",
      stars: 5,
    },
    {
      text: "The interface is neat and easy to use. Recently Viewed helps me revise words quickly. Highly recommended!",
      user: "Zineerah",
      stars: 5,
    },
    {
      text: "From vocabulary building to usage examples, this app has everything. One of the best Tamil dictionary apps out there.",
      user: "Lavanya",
      stars: 4,
    },
    {
      text: "I’ve been using Minagaram for months now. The content is rich, updated, and reliable. Great work by the team!",
      user: "Aravind",
      stars: 4,
    },
  ];
  const cardData = [
    {
      title: "Word of the day",
      description:
        "Learn a word each day with its meaning, usage, and synonyms to improve your vocabulary and enhance your language skills.",
      image: Word_of_the_image,
    },
    {
      title: "Image",
      description:
        "Words with images help connect meaning visually without cost, making vocabulary easier to learn and remember.",
      image: image,
    },
    {
      title: "Audio",
      description:
        "Click the audio symbol beside a word to hear its correct pronunciation. Great for learners to improve their speaking skills.",
      image: audio,
    },
    {
      title: "Select levels",
      description:
        "Select from Elementary, Intermediate, or Advanced levels. Progressively deepen your understanding of word usage and meaning.",
      image: select_level,
    },
    {
      title: "Recently Viewed",
      description:
        "The ‘Recently Viewed’ page shows the words you explored earlier. It helps you review and reinforce your learning.",
      image: recently_view,
    },
    {
      title: "Saved",
      description:
        "The ‘Saved Words’ page stores the words you bookmarked. Revisit them anytime to strengthen your vocabulary.",
      image: saved,
    },
    {
      title: "Idioms",
      description:
        "Idioms are expressions with meanings that differ from the literal words. Learn them with examples and contextual usage.",
      image: idioms,
    },
    {
      title: "Metaphor",
      description:
        "Explore how metaphors convey one concept through another, adding depth to your understanding of language.",
      image: idioms,
    },
    {
      title: "Phrasemes",
      description:
        "Understand common word pairs and set phrases used in language. Mastering phrasemes improves fluency and accuracy.",
      image: idioms,
    },
  ];

  const settings = {
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false, // ✔ enable arrows

    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
      // {
      //   breakpoint: 500,
      //   settings: {
      //     slidesToShow: 1,
      //     centerMode: false,
      //   },
      // },
    ],
  };

  let agarathi_token = localStorage.getItem("agarathi_token");

  const shareUrl = "http://13.126.65.58/Min-Landing";

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareUrl);
        message.success(
          isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
        );
      } else {
        // Fallback for non-secure contexts or browsers without clipboard API
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
          message.success(
            isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
          );
        } catch (err) {
          message.error(
            isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA
          );
        } finally {
          document.body.removeChild(textArea);
        }
      }
    } catch (error) {
      message.error(isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA);
    }
  };

  useEffect(() => {
    const openForgot = () => setIsForgotOpen(true);
    const openSignUp = () => setOpenSignUp(true);
    const openLogin = () => setIsModalOpen(true);

    window.addEventListener("openForgotPopup", openForgot);
    window.addEventListener("openSignupPopup", openSignUp);
    window.addEventListener("openLoginPopup", openLogin);

    return () => {
      window.removeEventListener("openForgotPopup", openForgot);
      window.removeEventListener("openSignupPopup", openSignUp);
      window.removeEventListener("openLoginPopup", openLogin);
    };
  }, []);

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </Menu.Item>
      {/* <Menu.Item key="2">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </Menu.Item>
      <Menu.Item key="3">
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </Menu.Item> */}
      <Menu.Item key="2" onClick={handleCopy}>
        <Button icon={<LinkOutlined />} type="link">
          {isTamil ? STR_Tam_Copy_STA : STR_Copy_STA}
        </Button>
      </Menu.Item>
    </Menu>
  );

  const scrollToDownload = () => {
    const el = document.getElementById("downloadSection");
    if (el) {
      el.scrollIntoView({ behavior: "auto", block: "start" });
      window.scrollBy(0, -90);
    }
  };

  return (
    <div
      className={`${"pp"}`}
      style={{
        background: `linear-gradient(90deg, rgba(230, 250, 250, 0.96) 0%, rgba(230, 250, 250, 0.92) 57%, rgba(230, 250, 250, 1) 55%, rgba(230, 250, 250, 0.76) 100%, rgba(230, 250, 250, 0.45) 100%)`,
      }}
    >
      <section className="intex_page" id="intex_pagesection">
        {/* Logo and Title */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Minagaramlogo}
            alt="Min Agaram Logo"
            style={{ width: "53px", marginRight: "10px" }}
          />
          <h1
            style={{ margin: 0, fontWeight: "600" }}
            className={styles.title_minagaram}
          >
            Min Agaram
          </h1>
        </div>
        {/* get the app Button */}
        <div className="header-right">
          <button className="get-app-btn" onClick={scrollToDownload}>
            Get the App
            <img src={ArrowUp} alt="arrow" className="arrow-icon" />
          </button>
          <button className="get-app-btn2" onClick={scrollToDownload}>
            <img src={download_button} alt="" className="download-icon" />
          </button>
          {/* Login Button */}
          <Button
            onClick={handleOpenLogin}
            type="primary"
            classNames="login_popup"
            style={{ borderRadius: "12px" }}
            icon={
              <img
                src={user_icon}
                alt="User"
                className="index_minagaram_button"
              />
            }
            shape="round"
            className="new_navication_bar"
          >
            Login
            <img src={ArrowUpRight} alt="Arrow" className="index_menu_button" />
          </Button>
          {
            <img
              src={profile_button}
              alt="User"
              className="index_profilebutton"
              onClick={handleOpenLogin}
            />
          }
          <LoginModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
          <ForgetPasswordModal
            open={isForgotOpen}
            onClose={() => setIsForgotOpen(false)}
          />
          <SignUpModal open={openSignUp} onClose={() => setOpenSignUp(false)} />
        </div>
      </section>
      <section class="main-section" id="mainSection">
        <div className={styles.new_container}>
          <img
            src={mainscreenipad}
            alt="MobileScreen"
            className="landing_image_ipad"
          />
          <div className="container_STA">
            <p className={styles.nuance}>
              Learn Tamil Smarter with{" "}
              <span className={styles.highlight}>Min Agaram</span>
            </p>
            <p className={styles.linguistic}>
              Expertly developed in Singapore, Minagaram brings you 50,000+
              words with a comprehensive, structured, and practical approach to
              mastering Tamil.
            </p>
            <p className={styles.uniqueness}>
              Experience the richness and uniqueness of Tamil — one of the
              world’s oldest and most beautiful languages. Whether you’re a
              beginner, student, or language enthusiast, Minagaram makes Tamil
              learning easy, intuitive, and engaging.
            </p>
            <p className={styles.underline}></p>
            <p className={styles.get_minAgaram}>
              Download Minagaram Today and Elevate Your Tamil Skills!{" "}
            </p>
            <div className="dotimg">
              <img src={dot_image} alt="" className="dot_image" />
            </div>
            {/* <div className={styles.PlayStorelogo}>
            <div className="shareButton_STA">
              <a
                href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppStorelogo}
                  alt="App Store"
                  className="AppStorelogo"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={PlayStorelogo}
                  alt="Google Play"
                  className="PlayStorelogo"
                />
              </a>
            </div>
          </div> */}
          </div>
          <img
            src={mainscreenmobile}
            alt="MobileScreen"
            className="landing_image_mobile"
          />
        </div>
      </section>
      <div className="section2_aboutus">
        <div className="childimg_about">
          <img src={childimg} alt="aboutus" className="childimg" />
        </div>
        <div className="aboutus_content">
          <p className={styles.underline_2}></p>
          <p className="about_title">
            <span className="dash">–</span> About Us
          </p>
          <h2 className="about_heading">
            Explore the <span className={styles.highlightss}>Tamilverse</span>
          </h2>
          <div className="childimg_about2">
            <img src={childimg} alt="aboutus" className="childimg_2" />
          </div>
          <span className="abt_subheading">
            <p>Step into a modern, simplified way of learning Tamil.</p>
            <p>
              Minagaram brings you a rich, curated Tamil dictionary designed to
              help learners of all levels understand the language with clarity
              and confidence.
            </p>
          </span>
          <div className="about_title02">What We Offer</div>

          <ul className="about_list">
            <li>
              <img src={tick} alt="" className="tick_img" />
              50,000+ curated Tamil words for everyday learning and advanced
              use.{" "}
            </li>
            <li>
              <img src={tick} alt="" className="tick_img" />
              Clear, real-life example sentences to help you understand each
              word in context.
            </li>
            <li>
              <img src={tick} alt="" className="tick_img" />
              Accurate meanings, grammar details, and word types explained
              simply.
            </li>
            <li>
              <img src={tick} alt="" className="tick_img" />
              Easy vocabulary expansion with structured learning tools.
            </li>
          </ul>
          <div className="dot2_img">
            <img src={dot_image} alt="" className="dot2_image" />
          </div>
        </div>
      </div>
      <section class="download-section" id="downloadSection">
        <div class="download-container">
          {/* <!-- LEFT CONTENT --> */}
          <div class="download-left">
            <h2 class="download-title">
              Download the <span class="highlighter">Min Agaram</span>
              <br />
              App Today!
            </h2>

            <p class="download-desc">
              Embark on a meaningful journey into the Tamil language — learn,
              explore, and experience its depth with every word.
            </p>

            <div class="stats">
              <div class="stat-block">
                <h3>3000+</h3>
                <p>Active Users</p>
              </div>

              <div class="divider"></div>

              <div class="stat-block">
                <h3>50000 +</h3>
                <p>Words</p>
              </div>
            </div>
            <p class="download-bottom">
              Start learning smarter. Start learning Tamil with Minagaram.
            </p>
            <p class="download-bot"></p>
          </div>

          {/* <!-- RIGHT CARDS --> */}
          <div class="download-right">
            <div className="download-card">
              <img src={iphone_scan} alt="iphone" className="card-bg" />

              <div className="overlay">
                <p className="title">For iOS</p>
                <a
                  href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>
              </div>
            </div>
            <div className="download-card">
              <img src={android_scan} alt="android_scan" className="card-bg" />
              <div className="overlay">
                <p className="title">For Android</p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="features-sec">
        <div class="features-container">
          <h2 class="feature-title">
            {/* <img src={bckgrd_box} className="bckgrd_box" /> */}
            <span class="highlightkey">Key Features</span> of <br /> Min Agaram
            App
          </h2>

          <div class="feature-cards">
            {/* <!-- 1 — Recently Viewed (content OVER image) --> */}
            <div class="feature-card overlay-card">
              <div class="image-container">
                <img
                  src={recent_viewed}
                  alt="Recently Viewed"
                  class="feature-img"
                />
                <img
                  src={recentview_tab}
                  alt="Recently Viewed"
                  class="feature-imgtab"
                />
                <img
                  src={recentview_phone}
                  alt="Recently Viewed"
                  class="feature-imgphone"
                />
                <div class="image-content">
                  <h3 class="feature-heading">Recently Viewed</h3>
                  <p class="feature-desc">
                    Easily resume your learning journey from where you left
                    off—never lose track of the words you've explored.
                  </p>
                </div>
                <div class="feature-blue-card">
                  <h3 class="feature-head">Recently Viewed</h3>
                  <p class="feature-text">
                    Easily resume your learning journey from where you left
                    off—never lose track of the words you've explored.
                  </p>
                </div>
              </div>
            </div>

            {/* <!-- 2 — Word of the Day (IMAGE FIRST → content OVER image) --> */}
            <div class="feature-card overlay-card">
              <div class="image-container">
                <img
                  src={wordofday}
                  alt="Word of the Day"
                  class="feature-img"
                />
                <img
                  src={wordofday_tab}
                  alt="Word of the Day"
                  class="feature-imgtab"
                />
                <img
                  src={wordofday_phone}
                  alt="Word of the Day"
                  class="feature-imgphone"
                />
                <div class="image-content_02">
                  <h3 class="feature-heading">Word of the Day</h3>
                  <p class="feature-desc">
                    Discover a new Tamil word every day and steadily expand your
                    vocabulary and cultural understanding.
                  </p>
                </div>
                <div class="feature-blue-card">
                  <h3 class="feature-head">Word of the Day</h3>
                  <p class="feature-text">
                    Discover a new Tamil word every day and steadily expand your
                    vocabulary and cultural understanding.
                  </p>
                </div>
              </div>
            </div>

            {/* <!-- 3 — Smart Search (content OVER image) --> */}
            <div class="feature-card overlay-card">
              <div class="image-container">
                <img
                  src={smart_search}
                  alt="Smart Search"
                  class="feature-img"
                />
                <img
                  src={smartsearch_tab}
                  alt="Smart Search"
                  class="feature-imgtab"
                />
                <img
                  src={smartsearch_phone}
                  alt="Smart Search"
                  class="feature-imgphone"
                />
                <div class="image-content">
                  <h3 class="feature-heading">Smart Search</h3>
                  <p class="feature-desc">
                    Quickly find any Tamil word with accurate meanings, clear
                    explanations, and real-life examples—all in just a few taps.
                  </p>
                </div>
                <div class="feature-blue-card">
                  <h3 class="feature-head">Smart Search</h3>
                  <p class="feature-text">
                    Quickly find any Tamil word with accurate meanings, clear
                    explanations, and real-life examples—all in just a few taps.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section
        className={styles.hero}
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <h2 className={styles.headline}>Explore the Tamilverse</h2>

        <img src={phone} alt="Min Agaram phone demo" className={styles.phone} />

        <Callout
          text="Notification"
          desc="Notifications in Min Agaram keep users
updated on new words, tips, and app
enhancements."
          side={styles.top}
        />
        <Callout
          text="Search Bar"
          desc="The Search Bar in Min Agaram
enables quick and accurate word
search with smart suggestions."
          side={styles.right}
        />
        <Callout
          text="Saved Words"
          desc="The Saved Words feature in Min
Agaram lets users bookmark and
revisit important words easily."
          side={styles.bottomRight}
        />
        <Callout
          text="Word of the Day"
          desc="The Word of the Day in Min Agaram
helps users learn a new Tamil word
daily and expand their vocabulary."
          side={styles.bottomLeft}
        />
        <Callout
          text="Navigation Bar"
          desc="Allows users to access essential
features quickly for an efficient and
user-friendly experience."
          side={styles.left}
        />
      </section> */}
      <div>
        <div className="share_page_01">
          {/* <div className="share_grid_02">
            <Card icon={Word_of_the_image} title="Word of the day" />
            <Card icon={icon2} title="Image" />
            <Card icon={icon3} title="Audio" />
            <Card icon={icon4} title="Select levels" />
            <Card icon={icon5} title="Recently Viewed" />
            <Card icon={icon6} title="Saved Words" />
            <Card icon={icon7} title="Idioms" />
            <Card icon={icon8} title="Metaphors" />
            <Card icon={icon9} title="Phrasemes" />
          </div> */}

          <div className="landing-container">
            <h2 className="landing-container-title">
              Why You’ll Love Minagaram
            </h2>
            <div className="landing-container-grid">
              {cardData.map((card, index) => (
                <div className="landing-container-card" key={index}>
                  <div className="landing-container-icon">
                    <img src={card.image} alt={card.title} />
                  </div>
                  <h3 className="landing-container-card-title">{card.title}</h3>
                  <p className="landing-container-card-desc">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="feedback_container">
        <div className="feed_head">
          <div className="head_01">A Dictionary That Grows With You</div>
          <p className="head_02">
            From daily-use words to advanced vocabulary — we cover it all.
          </p>
          <p className="head_02">Learn Tamil at your pace, the smart way.</p>
        </div>
        <div className="feedback_row">
          {/* LEFT SIDE */}
          <div className="feedback_left">
            <img src={quote} alt="" className="quote-img" />
            <h1 className="content_left">What Our Customers Are Saying</h1>
            <img src={arrow_line} alt="" className="arrow_line" />
          </div>

          {/* RIGHT SIDE - SLIDER */}
          <div className="feedback_right">
            <Slider {...settings}>
              {testimonials.map((item, i) => (
                <div key={i} className="testimonial-slide">
                  <div className="testimonial-card">
                    <p className="testimonial-text">{item.text}</p>
                    <div className="testimonial-rating">
                      {[...Array(item.stars)].map((_, index) => (
                        <img
                          key={index}
                          src={feedstar}
                          alt="star"
                          className="star-icon"
                        />
                      ))}
                    </div>
                    <p className="testimonial-user">{item.user}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className="new_landing_footer">
        <Footers_index />
      </div>
    </div>
  );
};

function Callout({ text, desc, side }) {
  return (
    <div className={`${styles.callout} ${side}`}>
      <h4>{text}</h4>
      <p>{desc}</p>
      <span className={styles.line} />
    </div>
  );
}
// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});

export default connect(mapStateToProps)(SharethisApp);
